<div class="page-header">
  <span class="page-header-left flex-inline-body">
    <a class="page-icon" style="cursor: pointer;" (click)="cancel()"><i class="{{icon}}"></i></a>
    <span class="page-title align-center">{{title}}</span>
  </span>
  <span class="page-header-right"></span>
</div>

<p-dialog [(visible)]="confirmAddAf" [modal]="true"  [style]="{ minWidth: '350px' }" [minY]="70">
  <p-header>
      Confirmation requested
  </p-header>
  <div class="m-b-12">Are you sure, these changes will be discarded?
      <br>
  </div>
  <p-footer>
      <div class="text-right">
          <button pButton type="button" label="Yes" class="p-button-tertiary" (click)="confirmYes()"></button>
          <button pButton type="button" label="No" class="p-button-tertiary" (click)="confirmNo()"></button>
      </div>
  </p-footer>
</p-dialog>
